import React from "react";
import { Link } from "react-router-dom";
import { ButtonProps } from "."
import "../../../styles/css/components/ui/button.css"

export const InterfaceButton = (props: ButtonProps) => {
  let classNames = ["interface_button", props.variant, props.size];

  if (props.className) { classNames.push(props.className); }
  if (props.noUnderline) { classNames.push("no-underline"); }

  if (props.to) {
    return (
      <Link
        id={props.id}
        className={classNames.join(" ")}
        to={props.to}
        onClick={props.onClick}>
        {props.children}
      </Link>
    )
  }

  return (
    <button 
      id={props.id}
      className={classNames.join(" ")}
      onClick={props.onClick}>
        {props.children}
    </button>
  );
};